/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

/**
 * Removes all occurrences of the substrings from the main string.
 *
 * This function takes a main string and an array of substrings. It removes all
 * occurrences of the substrings from the main string and returns the resulting string.
 *
 * @param {string} mainString - The main string from which substrings will be removed.
 * @param {string[]} substrings - An array of substrings to be removed from the main string.
 * @returns {string} - The resulting string after removing the substrings.
 *
 * @example
 * // Example 1:
 * const mainStr = "This is a test string that contains some test words.";
 * const subStrs = ["test", "words", "some"];
 * const result = removeSubstrings(mainStr, subStrs);
 * console.log(result); // Output: "This is a  string that contains  ."
 *
 * @example
 * // Example 2:
 * const mainStr = "Hello world! This is an example.";
 * const subStrs = ["Hello", "example"];
 * const result = removeSubstrings(mainStr, subStrs);
 * console.log(result); // Output: " world! This is an ."
 */
export function removeSubstrings(mainString, substrings) {
  let result = mainString;
  substrings.forEach((subString) => {
    result = result.split(subString).join('');
  });
  return result;
}
